module.exports = __webpack_public_path__ + "media/morning_day_off.7e651895.ogg";